import { useQuery } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../Context/AuthContext';


const fetchFundingSources = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/data/readFundingSources`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch funding sources');
  }

  return response.json();
};


const useFetchFundingSources = () => {
  const { token } = useContext(AuthContext); 

  return useQuery('fundingSources', () => fetchFundingSources(token)); 
};

export default useFetchFundingSources;
